import React, { useEffect, useState } from "react";
import logoDesktopBlanc from "@assets/img/logo/kWh50-Logo_Blanctransparent.png";
import logoDesktopCouleur from "@assets/img/logo/kWh50-Logo_Couleursfond blanc.png";
import "./navBar.scss";
import { Link } from "react-router-dom";
import {
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    Image,
    useDisclosure,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
} from "@chakra-ui/react";
import { IoMenu } from "react-icons/io5";
import { useLoginStore } from "@store/loginStore";
import LogoInnoExpe from "@assets/img/logo/logo_inno_expe.webp"
import LogoRegionBretagne from "@assets/img/logo/region-bretagne-logo.png"

const NavBar = () => {
    const [links, setLinks] = useState([
        { name: "Contact", path: "/contact", type: "link" },
        { name: "Connexion", path: "/login", type: "button" },
        { name: "Démo", path: "/login", type: "button" },
    ]);

    const linksLogged = [
        { name: "Contact", path: "/contact", type: "link" },
        { name: "Mes bâtiments", path: "/user/mes-sites", type: "button" },
        { name: "Déconnexion", path: "/user/logout", type: "button" },
    ];

    const [isOnTop, setIsOnTop] = React.useState(true);
    const { onOpen, isOpen, onClose } = useDisclosure();
    const { isLogin } = useLoginStore();

    useEffect(() => {

        if (isLogin) {
            setLinks(linksLogged)
        }

        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                setIsOnTop(false);
            } else {
                setIsOnTop(true);
            }
        });
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div
                id="navBar"
                className={isOnTop ? "" : "scrolled-nav"}
            >
                <nav>
                    <div>
                        <Link to={"/"}>
                            <img
                                id="logo-kwh"
                                src={
                                    isOnTop ? logoDesktopBlanc : logoDesktopCouleur
                                }
                                alt="Logo Kilowattheure50"
                            />
                        </Link>
                        <Popover>
                            <PopoverTrigger>
                                <img className="logo-region-bretagne" src={LogoRegionBretagne} alt="Logo Inno Expe" />
                            </PopoverTrigger>
                            <PopoverContent maxWidth="520px" width="100vw" padding="15px">
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverHeader>
                                    <img id="logo-inno-expe" src={LogoInnoExpe} alt="Logo Inno Expe" />
                                </PopoverHeader>
                                <PopoverBody>
                                    Kilowattheure50 vient d’achever après plus d’un an d’opération
                                    l’expérimentation EEBAT4o. <br/> <br/>
                                    Entrant dans le dispositif Inno Expé
                                    Numérique d’Images & Réseaux, elle a été cofinancée par la
                                    Région Bretagne.<br /><br />
                                    Les expérimentateurs publics et privés étaient
                                    répartis sur le territoire français et ont pu voir les signatures
                                    énergétiques de leurs bâtiments en temps réel dans de
                                    multiples cas d’usages mêlant diversement CVC
                                    (Chauffage-Ventilation-Climatisation), USE (Usage Spécifique de
                                    l’Energie) et confort des occupants.
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>
                    </div>
                    <ul>
                        {links.map((link, index) => {
                            return (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className={link.type}
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <Button
                        className="btn-menu-mobile"
                        onClick={onOpen}
                        backgroundColor="transparent"
                        _hover={{ backgroundColor: "transparent" }}
                    >
                        <IoMenu
                            size={40}
                            color={isOnTop ? "white" : "#117166"}
                        />
                    </Button>
                    <Drawer
                        placement="right"
                        onClose={onClose}
                        isOpen={isOpen}
                        size="xs"
                    >
                        <DrawerOverlay />
                        <DrawerContent className="welcome-menu-drawer">
                            <DrawerCloseButton className="closeButton" />
                            <DrawerHeader>
                                <Flex
                                    marginLeft="5"
                                    marginRight="5"
                                >
                                    <Image
                                        src={logoDesktopCouleur}
                                        alt="Logo Kilowattheure50"
                                    />
                                </Flex>
                            </DrawerHeader>
                            <DrawerBody>
                                <div className="list-link-mobile">
                                    <Flex
                                        direction="column"
                                        align="center"
                                        justify="center"
                                        gap="10"
                                        marginTop="12"
                                    >
                                        {links.map((link, index) => {
                                            return (
                                                <Link
                                                    to={link.path}
                                                    className={link.type}
                                                    key={index}
                                                >
                                                    {link.name}
                                                </Link>
                                            );
                                        })}
                                    </Flex>
                                </div>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>
                </nav>
            </div>
        </>
    );
};

export default NavBar;
